import React, { useState } from "react";
import { Card, Button, Carousel } from "react-bootstrap";

function ThingsToDo() {
  const [itemsData, setItemsData] = useState([
    { itemTitle: "Food" },
    { itemTitle: "Travel" },
    { itemTitle: "Art" },
    { itemTitle: "Workshops" },
    { itemTitle: "Shopping" },
    { itemTitle: "Event" },
    { itemTitle: "Outdoor" },
    { itemTitle: "Entertainment" },
  ]);

  return (
    <div>
      <h1 style={{ color: "#E72129", fontWeight: "bold", marginLeft: 65 }}>
        Things to do
      </h1>
      <div style={{ textAlign: "center" }}>
        <div style={{ display: "inline-block" }}>
          <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-4">
            {itemsData.map((item) => {
              return (
                <div style={{ paddingBottom: 25 }}>
                  <br />

                  <div className="col d-flex justify-content-center">
                    <div
                      className="card"
                      style={{ height: 240, width: 240, borderRadius: 40 }}
                    >
                      <img
                        src="https://cdn.thecrazytourist.com/wp-content/uploads/2018/08/ccimage-shutterstock_571221049.jpg"
                        // class="card-img-top"
                        alt="Card image"
                        style={{ borderRadius: 40, height: 240 }}
                      />
                      <Card.ImgOverlay>
                        <Card.Text style={{ position: "absolute", bottom: 20 }}>
                          <h2 style={{ fontWeight: "bold", color: "white" }}>
                            {item.itemTitle}
                          </h2>
                        </Card.Text>
                      </Card.ImgOverlay>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThingsToDo;
